import {AppState} from "../store";

export const getContainerStatusPageFilter = (state: AppState) => state.containerStatusPage.filter
export const getContainerStatusPageState = (state: AppState) => state.containerStatusPage.state
